// part6.js
export const tableschema6 = {
    name_table: 'Розділ VІ. Відомості про використання сучасних інформаційних технологій на кінець звітного року(Державна статистика)',
    titles:[
        "Кількість комп'ютерів у закладі, усього, од.",
        "з них придбано за кошти бюджету",
        "не працюють",
        "термін придбання становить понад 5 років",
        "використовуються в управлінсько-господарській діяльності",
        "підключено до Інтернет",
        "підключено до Wi-Fi",
        "Кількість портативних комп'ютерів, ноутбуків, нетбуків, од",
        "Кількість планшетів, од",
        "Кількість інтерактивних комплексів, усього, од",
        "з них проекторів та інтерактивних дошок",
        "проекторів з інтерактивним модулем",
        "інтерактивних дисплеїв",
        "Кількість засобів візуалізації (без інтерактиву), усього, од",
        "з них проекторів",
        "телевізорів",
        "інше",
        "Кількість принтерів, од",
        "Швидкість фіксованого широкосмугового доступу до Інтернет:",
        "(рядки 6510–6540 необхідне позначити 1 або 2) до 10 Мбіт/с 1 - так; 2 - ні",
        "від 10 до 30 Мбіт/с 1 - так; 2 - ні",
        "від 30 до 100 Мбіт/с 1 - так; 2 - ні",
        "100 і більше Мбіт/с 1 - так; 2 - ні",
        "Швидкість безпроводового широкосмугового доступу до Інтернет:",
        "(рядки 6610–6640 необхідне позначити 1 або 2) до 10 Мбіт/с 1 - так; 2 - ні",
        "від 10 до 30 Мбіт/с 1 - так; 2 - ні",
        "від 30 до 100 Мбіт/с 1 - так; 2 - ні",
        "100 і більше Мбіт/с 1 - так; 2 - ні"
    ],
    parts:[
        {title: "Кількісне значення/обране значення", subtitle: "", fields:[
            "PC6100",
            "PC6110",
            "PC6120",
            "PC6130",
            "PC6140",
            "PC6150",
            "PC6160",
            "PC6170",
            "PC6180",
            "PC6200",
            "PC6210",
            "PC6220",
            "PC6230",
            "PC6300",
            "PC6310",
            "PC6320",
            "PC6330",
            "PC6400",
            "PC6500", // Додано відсутнє поле
            "PC6510",
            "PC6520",
            "PC6530",
            "PC6540",
            "PC6600", // Додано відсутнє поле
            "PC6610",
            "PC6620",
            "PC6630",
            "PC6640"
        ]}
    ],
    shorts:{
        titles:[
            "6100",
            "6110",
            "6120",
            "6130",
            "6140",
            "6150",
            "6160",
            "6170",
            "6180",
            "6200",
            "6210",
            "6220",
            "6230",
            "6300",
            "6310",
            "6320",
            "6330",
            "6400",
            "6500",
            "6510",
            "6520",
            "6530",
            "6540",
            "6600",
            "6610",
            "6620",
            "6630",
            "6640"
        ],
        parts:[
            "1"
        ],
        type:{
            enum: [
                "PC6510",
                "PC6520",
                "PC6530",
                "PC6540",
                "PC6610",
                "PC6620",
                "PC6630",
                "PC6640"
            ],
            aver:[]
        }
    }
};